import { Pipe, PipeTransform } from '@angular/core';
import { HelperFunctions } from '../../../../utils/helper.functions';
import { AuthService } from '../../../../global/services/auth.service';
import { DistanceUnit } from '../../../../global/enums/DistanceUnit';

@Pipe({
  name: 'formatDistanceUnitPipe',
})
export class FormatDistanceUnitPipe implements PipeTransform {
  constructor(private helperFunctions: HelperFunctions, private authService: AuthService) {}
  transform(value: number): string {
    const preferredDistanceUnit = this.authService.getDistanceUnit();
    if (preferredDistanceUnit === DistanceUnit.mile) return `${this.helperFunctions.metersToMiles(value)} miles`;
    return `${this.helperFunctions.metersToKM(value)} km`;
  }
}
